import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "errorMessage" }
const _hoisted_2 = { class: "signup-view__container" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_4 = { class: "signup-view__logo" }
const _hoisted_5 = { href: "http://www.airsquirrels.com/ditto/" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "signup-view__links d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "signup-view__help-link",
  href: "https://help.airsquirrels.com/ditto",
  target: "_blank",
  rel: "noreferrer noopener"
}, "Help & Support", -1)
const _hoisted_9 = {
  href: "/",
  class: "signup-view__login-button"
}
const _hoisted_10 = { class: "signup-view__form" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "my-3" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "An error occurred. Please try again.", -1)
const _hoisted_17 = { href: "#" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "/"
}, "I verified, log me in", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "signup-view__footer error-footer" }
const _hoisted_21 = { class: "signup-view__footer-container" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link",
    href: "http://www.airsquirrels.com/privacy-policy/"
  }, "Privacy Policy")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link",
    href: "http://www.airsquirrels.com/ditto/contact-sales"
  }, "Contact Us")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("img", {
              src: require('../assets/images/admin-logo-new@2x.png'),
              class: "signup-view__logo-img"
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _createTextVNode("Log In")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.parsedMessage), 1),
          (_ctx.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.resendVerificationSuccess === null)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: _ctx.resendVerificationEmail
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Resend Verification Email")
                          ]),
                          _: 1
                        }, 8, ["onClick"])), [
                          [_directive_loading, _ctx.sendingReverificationEmail]
                        ])
                      : (_ctx.resendVerificationSuccess === true)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Sent an email to " + _toDisplayString(_ctx.userEmail), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("a", _hoisted_17, [
                              _createVNode(_component_el_button, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Try again")
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                  ]),
                  _hoisted_18
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_el_button, { onClick: _ctx.onLogin }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log In")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "Copyright © " + _toDisplayString(_ctx.dateYear) + ". Squirrels, LLC. All rights reserved.", 1),
          _hoisted_22,
          _hoisted_23
        ])
      ])
    ])
  ]))
}